<template>
  <b-form-group label="Secondary Group" label-for="primary-group">
    <b-input-group >
      <b-form-tags
        id="tags-component-select"
        v-model="proxyValue"
        add-on-change
        no-outer-focus
      >
        <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
          <ul v-if="tags.length" class="list-inline d-inline-block">
            <li v-for="tag in tags" :key="tag" class="list-inline-item">
              <b-form-tag
                @remove="removeTag(tag)"
                :title="tag"
                :disabled="disabled"
                variant="info"
              >
                {{ tag }}
              </b-form-tag>
            </li>
          </ul>

          <b-form-select
            v-bind="inputAttrs"
            v-on="inputHandlers"
            :disabled="disabled || availableOptions.length === 0"
            :options="availableOptions"
          >
            <template #first>
              <!-- required to prevent Safari bugs -->
              <option disabled value="">Select…</option>
            </template>
          </b-form-select>
        </template>
      </b-form-tags>
    </b-input-group>
  </b-form-group>
</template>

<script>
export default {
  name: 'group-selection',
  props: {
    options: { type: Array, default: () => [] },
    // This prop is what v-model binds to in Vue 2
    value:   { type: Array, default: () => [] }
  },
  computed: {
    // Proxy computed with get/set to make v-model work
    proxyValue: {
      get() { return this.value },
      set(v) {
        this.value = v
        this.$emit('input', v)
        this.$emit('change', v)  // lets parent listen with @change
      }
    },
    availableOptions() {
      return this.options.filter(opt => this.proxyValue.indexOf(opt) === -1)
    }
  }
}
</script>
